export default "__VITE_ASSET__8eb35054__"